const doctorsActionTypes = {
  FETCH_DOCTORS_LIST: 'FETCH_DOCTORS_LIST',
  FETCH_DOCTORS_LIST_SUCCESS: 'FETCH_DOCTORS_LIST_SUCCESS',
  FETCH_DOCTORS_LIST_FAIL: 'FETCH_DOCTORS_LIST_FAIL',

  FETCH_UPDATE_DOCTOR_LICENCE_STATUS: 'FETCH_UPDATE_DOCTOR_LICENCE_STATUS',
  FETCH_UPDATE_DOCTOR_LICENCE_STATUS_SUCCESS: 'FETCH_UPDATE_DOCTOR_LICENCE_STATUS_SUCCESS',
  FETCH_UPDATE_DOCTOR_LICENCE_STATUS_FAIL: 'FETCH_UPDATE_DOCTOR_LICENCE_STATUS_FAIL',

  FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES: 'FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES',
  FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES_SUCCESS: 'FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES_SUCCESS',
  FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES_FAIL: 'FETCH_ASSIGN_OR_REVOKE_DOCTOR_BADGES_FAIL',
};

export default doctorsActionTypes;
